// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-6e4ee50f] {\n  font-size: 0.85em;\n  padding: 4px 10px;\n}", ""]);
// Exports
module.exports = exports;
